import { FileUploadIcon } from 'components/shared/Icons'
import { useEffect, useRef, useState } from 'react'
import { Button, Collapse, Modal, Table } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { APISERVICE } from 'services/api.service'

export default function ModalJustification({ show, onHide, loading, onJustify, horarioId }) {
    const fileRef = useRef(null)
    const [descripcion, setDescripcion] = useState('')
    const [justificar, setJustificar] = useState(false)
    const [reporte, setReporte] = useState(null)
    const [errors, setErrors] = useState({ descripcion: '', file: '' })

    useEffect(() => {
        const loadReporte = async () => {
            try {
                const url = 'verificacion/notification-schedule?'
                const params = horarioId.reduce((carry, id) => {
                    return carry ? carry + `&horario_id[]=${id}` : `horario_id[]=${id}`
                }, '')

                const { success, data } = await APISERVICE.get(url, params)
                if (success) {
                    setReporte(data)
                }
            } catch (error) {
                toast.error('Ocurrió un error')
            }
        }
        if (horarioId) loadReporte()
    }, [horarioId])

    const handleJustify = () => {
        if (justificar) {
            if (validateFile()) {
                const file = fileRef.current?.files.length > 0 ? fileRef.current.files[0] : undefined
                if (descripcion.trim() || file) {
                    if (validateDescripcion(descripcion)) {
                        onJustify({ descripcion, file })
                    }
                }
            }
        }
    }
    const handleChange = ({ target }) => {
        setDescripcion(target.value)
        validateDescripcion(target.value)
    }
    const validateDescripcion = (value) => {
        let isValid = true
        if (value.length > 500) {
            setErrors({ ...errors, descripcion: 'Longitud máxima de 500 caracteres' })
            isValid = false
        }
        isValid && errors.descripcion && setErrors({ ...errors, descripcion: '' })
        return isValid
    }
    const validateFile = () => {
        let isValid = true
        const file = fileRef.current?.files.length > 0 ? fileRef.current.files[0] : undefined
        if (file) {
            let ext = file.name.substring(file.name.length - 5)
            ext = ext.charAt(0) === '.' ? ext : ext.substring(1)
            if (!['.pdf', '.doc', '.docx', '.png', '.jpg', '.jpeg'].includes(ext)) {
                setErrors({
                    ...errors,
                    file: 'Formato de archivo no valido. Solo se permiten archivos pdf, doc, docx, png, jpg y jpeg',
                })
                isValid = false
            } else {
                errors.file && setErrors({ ...errors, file: '' })
            }
        } else {
            errors.file && setErrors({ ...errors, file: '' })
        }
        return isValid
    }

    return (
        <Modal show={show} centered>
            <Modal.Header>
                <span className='h5 mb-0'>Reporte de Asistencia</span>
            </Modal.Header>
            <Modal.Body>
                <div className='fs-5 mb-3'>Control de asistencia</div>
                <div className='mb-3'>
                    <span className='fw-bold'>Hora de entrada:</span> {reporte?.startClass?.hora_tikeo?.substring(11)}
                    <br />
                    <span className='fw-bold'>Hora de salida:</span> {reporte?.endClass?.hora_tikeo?.substring(11)}
                </div>
                <div className='fs-5 mb-3'>Control de permanencia</div>
                <Table className='text-center'>
                    <thead>
                        <tr>
                            <th>Hora de tiqueo</th>
                            <th>Tiqueo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reporte?.records?.length > 0 ? (
                            reporte.records.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.hora_tikeo.substring(11)}</td>
                                    <td>{item.tikeo ? 'Si' : <span className='text-danger'>No</span>}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={2}>No hay registros</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                <div className='form-check mb-3'>
                    <input
                        className='form-check-input cursor-pointer'
                        type='checkbox'
                        id='justificar'
                        checked={justificar}
                        onChange={({ target }) => setJustificar(target.checked)}
                    />
                    <label className='form-check-label cursor-pointer' htmlFor='justificar'>
                        Agregar justificación
                    </label>
                </div>
                <Collapse in={justificar}>
                    <div>
                        <div>
                            <textarea
                                className='justification-content'
                                placeholder='Ejm: Tuve problemas de conexión'
                                value={descripcion}
                                onChange={handleChange}
                            />
                            {errors.descripcion && <div className='msg-error'>{errors.descripcion}</div>}
                        </div>
                        <label className='custom-file' htmlFor='file'>
                            <span className='custom-file-icon'>
                                <FileUploadIcon />
                            </span>
                            {fileRef.current?.files.length > 0
                                ? fileRef.current.files[0].name
                                : 'Seleccione un archivo'}
                        </label>
                        <input
                            ref={fileRef}
                            type='file'
                            id='file'
                            accept='.pdf,.doc,.docx,.jpg,.png,.jpeg'
                            hidden
                            onChange={validateFile}
                        />
                        {errors.file && <div className='msg-error mt-2'>{errors.file}</div>}
                    </div>
                </Collapse>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={onHide} disabled={loading}>
                    Cerrar
                </Button>
                <Button variant='blue' onClick={handleJustify} disabled={loading || !justificar}>
                    Enviar Justificación
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
